<template>
  <div ref="whole_page">
    <div class="fixed-max-width-650" style="flex-wrap: wrap;">
      <div class="vx-row">
        <div class="vx-col w-full">
          <h2>Please give me a call to discuss</h2>
        </div>
      </div>
      <div class="vx-row mt-6">
        <div class="vx-col w-full">
          <h2><strong>{{ $route.query.n }}</strong></h2>
          <vs-divider class="red-divider mt-6" />
        </div>
      </div>
      <div class="vx-row mt-8">
        <div class="vx-col w-full">
          <h2>My Mobile Number</h2>
          <vs-input class="custom-input_large--no-border w-full mt-8" v-validate="'digits:10'" type="number" name="Mobile Number" v-model="mobileNumber" />
          <vs-divider class="red-divider mt-6" />
        </div>
      </div>
      <div class="vx-row mt-8">
        <div class="vx-col w-full">
          <h2>Best Time:</h2>
          <b-time v-model="bestTime" class="dark_time" hide-header @context="timeUpdated" locale="en" />
        </div>
        <div v-if="showInvalidTime" class="vx-col w-full mt-3">
          <h5>Please choose a time between <strong>07:30 AM</strong> and <strong>05:00 PM</strong></h5>
        </div>
      </div>
      <div class="vx-row mt-8">
        <div class="vx-col w-full">
          <vs-button v-if="!success" :disabled="!mobileNumber || !bestTime || showInvalidTime" id="create-callback_btn" ref="create_btn" class="w-full vs-con-loading__container" icon-pack="feather" icon="icon-phone-call" @click="createCallBack">SEND CALL BACK</vs-button>
          <vs-button v-else id="success-callback_btn" :disabled="true" class="w-full button__fully-opaque" icon-pack="feather" icon="icon-check">SUCCESS!</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {BTime} from 'bootstrap-vue'
  export default {
    data() {
      return {
        mobileNumber: "",
        bestTime: "",
        success: false,
        showInvalidTime: true
      }
    },
    components: {
      BTime
    },
    computed: {
      
    },
    watch: {
      
    },
    methods: {
      createCallBack() {
        var self = this;

        self.$validator.validateAll().then(result => {
          if (result) {
            self.showLoadingOnElement("create_btn", 1, "material");

            var onSuccess = response => {
              self.$vs.loading.close(self.$refs.create_btn.$el);
              self.success = true;
            };
            var onFinally = response => {
              if (self.$refs.create_btn) {
                self.$vs.loading.close(self.$refs.create_btn.$el);
              }
            };
            
            self.$ajaxGet(self, `MentorModule/CreateCallBack?moduleId=${self.$route.query.module}&number=${self.mobileNumber}&time=${self.bestTime}`, onSuccess, onFinally);
          } else {
            self.$validator.errors.items.forEach(function(error) {
              self.$vs.notify({
                title:'Attention',
                color: "warning",
                time: 5500,
                text: error.msg,
                position:'top-center',
                iconPack: 'feather',
                icon:'icon-info'
              });
            })
            
          }
        })
      },
      timeUpdated(context) {
        if (context.hours != null || context.minutes != null) {
          var hrs = context.hours;
          var min = context.minutes;

          if (hrs <= 7 && min < 30) {
            // console.log("choose a time of 07:30 or later");
            this.showInvalidTime = true;
            return;

          } else if(hrs < 7){
            this.showInvalidTime = true;
          }
          
          else if(hrs <= 7 && min >= 30){
            this.showInvalidTime = false;
          }
          else if (hrs >= 17 && min >= 0) {
            // console.log("choose a time earlier than 17:00");
            this.showInvalidTime = true;
            return;
          } else {
            // console.log("valid time");
            this.showInvalidTime = false;
            return;
          }
        }
      },
      showLoadingOnElement(element, scale, type, color) {
        var self = this;
        self.$vs.loading({
          color: color,
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      }
    },   
    mounted() {
      var self = this;
      
    },
  }

</script>

<style lang="scss">
.red-divider.vs-divider {
  .vs-divider-border {
    border-top: 2px solid rgba(255, 0, 0, 1) !important;
  }
}

.custom-input_large--no-border {
  .vs-input--input {
    border: none !important;
    height: 60px !important;
    font-size: 2.2rem !important;
    font-weight: 600 !important;
    text-align-last: center !important;
  }

  input {
    text-align: center !important;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
}

.dark_time {
  .form-control {
    border: 1px solid #10163a !important;
    color: white !important;
    background-color: #262d4a !important;
    height: 165px !important;

    &.b-form-spinbutton {
      .btn {
        line-height: 3 !important;
      }

      output {
        font-size: 23pt !important;
      }
    }

    &.flex-column {
      width: 80px !important;
    }
  }

  .btn {
    color: white !important;
  }
}

#create-callback_btn {
  justify-content: space-evenly !important;
  min-height: 140px !important;
  font-size: 3rem !important;
  border-radius: 25px !important;
  border-style: solid !important;
  border-width: 4px !important;
  border-color: rgba(0, 0, 0, 0.2) !important;
  background-image: linear-gradient(#b01538,  #dc1e26) !important;

  .vs-icon {
    font-size: 6rem !important;
  }

  .vs-button--text {
    text-align: right !important;
    font-weight: 600 !important;
    background: -webkit-linear-gradient(#c9c9c9, #c9c9c9) !important;
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent !important;
  }
}

#success-callback_btn {
  justify-content: space-evenly !important;
  height: 140px !important;
  font-size: 3rem !important;
  border-radius: 25px !important;
  border-style: solid !important;
  border-width: 4px !important;
  border-color: rgba(0, 0, 0, 0.2) !important;
  background-image: linear-gradient(#1caf00,  #037500) !important;

  .vs-icon {
    font-size: 6rem !important;
  }

  .vs-button--text {
    text-align: right !important;
    font-weight: 600 !important;
    background: -webkit-linear-gradient(#c9c9c9, #c9c9c9) !important;
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent !important;
  }
}
</style>
